import React from 'react';
import { DropdownIndicatorProps, components } from 'react-select';
import { ReactComponent as DownIcon } from 'images/actions/down-arrow.svg';
import { ReactComponent as DropdownIcon } from 'images/single-select-dropdown-arrow.svg';
import { Box } from '@primer/components';

export type DropdownIndicatorCustomPropType = {
    isSingleArrow?: boolean;
    arrowSize?: number;
};
const DropdownIndicator: React.FC<
    DropdownIndicatorProps & DropdownIndicatorCustomPropType
> = (dropdownProps) => {
    const { isSingleArrow, arrowSize = 10 } = dropdownProps;
    return (
        <components.DropdownIndicator {...dropdownProps}>
            <Box paddingRight="5px" display="flex">
                {isSingleArrow ? (
                    <DownIcon width={arrowSize} height={arrowSize} />
                ) : (
                    <DropdownIcon width={arrowSize} height={arrowSize} />
                )}
            </Box>
        </components.DropdownIndicator>
    );
};

export default DropdownIndicator;
